import React from 'react';
import COLORS from '../../constants/colors';
import ProductAttributeSet from '../../components/ProductAttributeSet';
import ProductAttribute from '../../components/ProductAttribute';
import SectionTitle from '../../components/SectionTitle';
import paletteIcon from './assets/palette.png';
import buttonIcon from './assets/button.png';
import fontIcon from './assets/font.png';

const paletteDescription = (
  <span>
    A carefully chosen color palette communicates the
    vibe of your business. Dark greys for feelings of security and vibrant
    greens for feelings of youthfulness. A guide contains your primary colors,
    secondary colors, type colors, and button colors.
  </span>
);

const buttonDescription = (
  <span>
    Button styles are your button colors and button text. Although its a small
    detail it's one of the first thtings users notice to get in touch or buy your
    product. We also included a button animation guide for "click" and "hover"
    effects.
  </span>
);

const fontDescription = (
  <span>
    Fitting fonts are important for creating a strong brand and good website.
    Like colors, font types communicate the "vibe" of your business. Do you want
    to communicate strength? Or maybe playfulness? Fonts can help users know
    what you're like. You'll get both the font files and type guide for future
    reference.
  </span>
);

function ProductStyleElements({ color }) {
  return (
    <div>
      <SectionTitle color={color}>
        STYLE ELEMENTS&nbsp;
        <span style={{ color: COLORS.GREEN }}> &#x25CF;</span>
        <span style={{ color: COLORS.BLUE }}> &#x25CF;</span>
        <span style={{ color: COLORS.PURPLE }}> &#x25CF;</span>
      </SectionTitle>
      <ProductAttributeSet>
        <div className="row">
          <ProductAttribute
            icon={paletteIcon}
            title="COLOR PALETTE"
            description={paletteDescription}
          />
          <ProductAttribute
            icon={buttonIcon}
            title="BUTTON STYLES, ANIMATIONS"
            description={buttonDescription}
          />
        </div>
        <div className="row">
          <ProductAttribute
            icon={fontIcon}
            title="FONT & TYPE GUIDE"
            description={fontDescription}
          />
        </div>
      </ProductAttributeSet>
    </div>
  );
}

export default ProductStyleElements;



// WEBPACK FOOTER //
// ./src/components/ProductStyleElements/index.js